export const CURRICULUM_TIME_UNITS = ['week', 'semester', 'year'] as const

export type CurriculumTimeUnit = (typeof CURRICULUM_TIME_UNITS)[number]
